import ApiService from "../ApiService";
import { StorageService } from "../StorageService";

const vademecumService = {
    getVademecumOrder(data) {
        return ApiService.customRequest({
            url: `${process.env.VUE_APP_ROOT_API}/master-medicines/`,
            method: "get",
            data,
        });
    },
    createVademecun(data) {
        return ApiService.customRequest({
            url: `${process.env.VUE_APP_ROOT_API}/master-medicines/save/`,
            method: "post",
            data,
        });
    },
    updateVademecun(id, data) {
        return ApiService.customRequest({
            url: `${process.env.VUE_APP_ROOT_API}/master-medicines/` + id,
            method: "put",
            data,
        });
    },
    deleteVademecun(formData) {
        return ApiService.customRequest({
            url: `${process.env.VUE_APP_ROOT_API}/master-medicines/` + formData,
            method: "delete",
        });
    },
};

export default vademecumService;